<template>
  <b-modal :id="id" size="lg" lazy hide-footer v-model="visible" header-class="border-0" modal-class="contact-profile-modal" body-class="pt-0" v-if="contact">
    <template v-slot:modal-header="{ close }">
      <div class="d-flex flex-row justify-content-end w-100">
        <b-btn v-if="$listeners.delete" class="text-danger py-0 mr-2" @click="() => $emit('delete', contact)" variant="transparent">
          <font-awesome-icon icon="trash"/>
        </b-btn>
        <b-button-close class="m-0 py-0" @click="close"/>
      </div>
    </template>

    <b-row class="d-flex flex-column justify-content-center">
      <img :src="`/static/images/avatars/main${contact.avatar || 1}.png`" class="contact-picture mb-3"/>
      <template v-if="isRecruiter">
        <div class="current-workplace workplace text-center" v-if="contact.latestEmployment">
          <div class="standard-black-title">{{ contact.latestEmployment.title || '&nbsp;' }}</div>
          <div class="company secondary-color">Most recently at <b>{{ contact.latestEmployment.companyName }}</b></div>
          <div class="time secondary-color" v-if="contact.latestEmployment.startDate">
            <template v-if="contact.latestEmployment.startDate">
              {{formatDate(contact.latestEmployment.startDate, 'YYYY')}} - {{ contact.latestEmployment.endDate ? formatDate(contact.latestEmployment.endDate, 'YYYY') : 'Present' }}
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="current-workplace workplace text-center">
          <div class="standard-black-title">{{ contact.fullName }}</div>
          <template v-if="contact.latestEmployment">
            <div class="standard-black-title">{{ contact.latestEmployment.title || '&nbsp;' }}</div>
            <div class="small-font secondary-color" v-if="contact.latestEmployment.companyName">Currently working in <b>{{ contact.latestEmployment.companyName }}</b></div>
          </template>
        </div>
      </template>
    </b-row>

    <b-row class="d-flex flex-column">
      <div class="location mt-3 bg-light" v-if="currentLocation">
        <font-awesome-icon class="mr-3 grey" icon="map-marker"/> Current work location is <strong>{{ currentLocation }}</strong>
      </div>
      <div class="mt-2 d-flex flex-row" v-if="!isRecruiter && profiles">
        <div class="mx-2 px-2 py-1" v-if="profiles.facebook">
          <a :href="`https://${profiles.facebook}`" target="_blank">
            <font-awesome-icon :icon="[ 'fab', 'facebook' ]"/>
          </a>
        </div>
        <div class="mx-2 px-2 py-1" v-if="profiles.twitter">
          <a :href="`https://${profiles.twitter}`" target="_blank">
            <font-awesome-icon :icon="[ 'fab', 'twitter' ]"/>
          </a>
        </div>
        <div class="mx-2 px-2 py-1" v-if="profiles.linkedin">
          <a :href="`https://${profiles.linkedin}`" target="_blank">
            <font-awesome-icon :icon="[ 'fab', 'linkedin' ]"/>
          </a>
        </div>
      </div>
    </b-row>

    <hr/>

    <b-row class="history mx-5">
      <b-col class="p-3" cols="12" md="6">
        <strong class="history-title">Work History</strong>
        <!-- <div class="history-block" v-if="contact.latestEmployment">
          <div v-if="contact.latestEmployment.startDate" class="grey">{{formatDate(contact.latestEmployment.startDate, 'YYYY')}} - <span v-if="contact.latestEmployment.endDate">{{formatDate(contact.latestEmployment.endDate, 'YYYY')}}</span><span v-else>Present</span></div>
          <div v-if="contact.latestEmployment.title">
            <b>{{contact.latestEmployment.title}}</b><br>
          </div>
          <div v-if="contact.latestEmployment.companyName">{{contact.latestEmployment.companyName}}</div>
        </div> -->
        <template v-if="Array.isArray(contact.previousEmployment) && contact.previousEmployment.length">
          <div class="history-block" v-for="(employment, i) in contact.previousEmployment" :key="i">
            <div v-if="employment.startDate" class="grey">
              {{formatDate(employment.startDate, 'YYYY')}}<template v-if="employment.endDate"> - {{formatDate(employment.endDate, 'YYYY')}}</template>
            </div>
            <div v-if="employment.title">
              <b>{{employment.title}}</b><br>
            </div>
            <div v-if="employment.companyName">{{employment.companyName}}</div>
          </div>
        </template>
        <div v-else>
          <p>Not Available</p>
        </div>
      </b-col>
      <b-col class="p-3" cols="12" md="6">
        <strong class="history-title">Education History</strong>

        <template v-if="contact.latestEducation || (Array.isArray(contact.previousEmployment) && contact.previousEmployment.length)">
          <div class="history-block" v-if="contact.latestEducation">
            <div v-if="contact.latestEducation.startDate" class="grey">{{formatDate(contact.latestEducation.startDate, 'YYYY')}} - {{formatDate(contact.latestEducation.endDate, 'YYYY')}}</div>
            <div v-if="contact.latestEducation.degreeName"><b>{{contact.latestEducation.degreeName}}</b><br></div>
            <div v-if="contact.latestEducation.schoolName"><b>{{contact.latestEducation.schoolName}}</b></div>
          </div>
          <div class="history-block" v-for="(education, i) in contact.previousEducation" :key="i">
            <div v-if="education.startDate" class="grey">{{formatDate(education.startDate, 'YYYY')}}<template v-if="education.endDate"> - {{formatDate(education.endDate, 'YYYY')}}</template></div>
            <div v-if="education.degreeName"><b>{{education.degreeName}}</b><br></div>
            <div v-if="education.schoolName"><b>{{education.schoolName}}</b></div>
          </div>
        </template>
        <div v-else>
          <p>Not Available</p>
        </div>
      </b-col>

      <div class="w-100"/>

      <b-col class="p-3" cols="12" md="6">
        <strong class="history-title">Industries</strong>
        <template v-if="contact && Array.isArray(contact.industries) && contact.industries.length">
          <b-row>
            <b-col v-for="value in contact.industries" :key="value" cols="12" sm="6"><p class="m-0 small-font">{{ value }}</p></b-col>
          </b-row>
        </template>
        <div v-else>
          <p>Not Available</p>
        </div>
      </b-col>
      <b-col class="p-3" cols="12" md="6">
        <strong class="history-title">Skills</strong>
        <template v-if="contact && Array.isArray(contact.skills) && contact.skills.length">
          <b-row>
            <b-col v-for="value in contact.skills" :key="value" cols="12" sm="6"><p class="m-0 small-font">{{ value }}</p></b-col>
          </b-row>
        </template>
        <div v-else>
          <p>Not Available</p>
        </div>
      </b-col>
    </b-row>

    <div class="mx-5 px-3">
      <div class="time small-font secondary-color text-center" v-if="!showDataUpdateDisclaimer">
        Data is updated periodically
        <a class="text-muted text-decoration-none" href="#" @click.prevent="() => showDataUpdateDisclaimer = !showDataUpdateDisclaimer">
          <strong>(?)</strong>
        </a>
      </div>
      <div class="small-font secondary-color" v-if="showDataUpdateDisclaimer">
        Data is updated periodically and so will not always show the most up to date work or education history of a
        candidate, however we update this data from time to time.  If you would like more information about our data
        processing policy, please read our <a href="https://www.reallinks.io/privacy-policy/" target="_blank">privacy policy</a>.
        <a class="text-muted text-decoration-none" href="#" @click.prevent="() => showDataUpdateDisclaimer = !showDataUpdateDisclaimer">
          <strong>&times;</strong>
        </a>
      </div>
    </div>

    <template v-if="previousReferrals.length || previousReferralRequests.length || matchedJobs.length">
      <hr/>
      <b-row class="mx-5 py-3">
        <b-col cols="12">
          <ul v-if="previousReferrals.length" class="list-unstyled">
            <li>
              <strong v-if="isSainsburys">Already Introduced</strong>
              <strong>Already Referred</strong>
            </li>
            <li v-for="referral in previousReferrals" :key="referral.id">
              <strong v-if="$route.name === 'EventRoom'">
                {{ referral.job.title }}
              </strong>
              <template v-else>
                <router-link :to="{ name: 'JobShow', params: { jobID: referral.job.id } }" target="_blank">
                  {{ referral.job.title }}
                </router-link>
                <span v-if="$route.name === 'JobShow' && $route.params.jobID === referral.job.id" class="text-muted">
                  (this role)
                </span>
              </template>

              <template v-if="referral.user && referral.user.id === user.id">by you</template>
              <template v-else-if="isRecruiter && referral.user && referral.user.fullName">
                by {{ referral.user.fullName }}
              </template>
              <template v-else-if="!isRecruiter && referral.user && referral.user.id">
                by another
              </template>

              <span v-if="referral.created" class="text-muted">
                &mdash; {{ referral.created | formatDateRelative({ addSuffix: true }) }}
              </span>
            </li>
          </ul>
          <ul v-if="isRecruiter && previousReferralRequests.length" class="list-unstyled">
            <li>
              <strong v-if="isSainsburys">Introductions Requested</strong>
              <strong>Referrals Requested</strong>
            </li>
            <li v-for="referral in previousReferralRequests" :key="referral.id">
              <strong v-if="$route.name === 'JobShow' && $route.params.jobID === referral.job.id">
                {{ referral.job.title }}
              </strong>
              <strong v-else-if="$route.name === 'EventRoom'">
                {{ referral.job.title }}
              </strong>
              <router-link v-else :to="{ name: 'JobShow', params: { jobID: referral.job.id } }" target="_blank">
                {{ referral.job.title }}
              </router-link>

              <template v-if="referral.user && referral.user.id === user.id">sent to you</template>
              <template v-else-if="referral.user && referral.user.fullName">sent to {{ referral.user.fullName }}</template>

              <template v-if="referral.recruiter && referral.recruiter.id === user.id">by you</template>
              <template v-else-if="referral.recruiter && referral.recruiter.fullName">by {{ referral.recruiter.fullName }}</template>

              <span v-if="referral.created" class="text-muted">
                &mdash; {{ referral.created | formatDateRelative({ addSuffix: true }) }}
              </span>
            </li>
          </ul>
        </b-col>
        <!-- <b-col cols="12" v-if="Array.isArray(matchedJobs) && matchedJobs.length">
          <strong>Matched Jobs</strong>

          <b-row class="mx-4 px-2 py-2 border-bottom" v-for="job in matchedJobs" :key="job.id">
            <b-col cols="9" class="p-2 d-flex align-items-center" @click="$router.push(`/jobs/${job.id}`)">
              <div class="standard-black-title">{{job.title}}</div>
            </b-col>
            <b-col cols="3" class="p-2 d-flex justify-content-end">
              <b-button variant="primary" @click="() => $emit('referContact', { contactID: contact.id, jobID: job.id })">
                Refer
              </b-button>
            </b-col>
          </b-row>
        </b-col> -->
      </b-row>
    </template>

  </b-modal>
</template>

<script>
import formatDate from 'date-fns/format';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'ContactProfileModal',
  props: {
    id: {
      type: String,
      required: true,
    },
    contact: {
      type: Object,
      validate: contact => contact && contact.id,
    },
  },
  data: () => ({
    visible: false,
    showDataUpdateDisclaimer: false,
  }),
  computed: {
    ...mapRoot([ 'user', 'isRecruiter', 'isSainsburys' ]),
    currentLocation() {
      const { locations } = this.contact || {};
      if (Array.isArray(locations)) {
        const { city, country } = locations.find(l => l && l.isPrimary && (l.city || l.country)) || locations.find(l => l && (l.city || l.country)) || {};
        return (city || country) ? `${city || ''}${city && country ? ', ' : ''}${country || ''}`.trim() : null;
      } else {
        return null;
      }
    },
    matchedJobs() {
      return (this.contact && Array.isArray(this.contact.matchedJobs) ? this.contact.matchedJobs : []);
    },
    previousReferrals() {
      return (this.contact && Array.isArray(this.contact.referrals) ? this.contact.referrals : []).filter(referral => {
        const { job, status } = referral;
        return job && job.id && status === 'ACCEPTED';
      });
    },
    previousReferralRequests() {
      return (this.contact && Array.isArray(this.contact.referrals) ? this.contact.referrals : []).filter(referral => {
        const { job, recruiter, status } = referral;
        return job && job.id && recruiter && recruiter.id && status === 'REQUESTED';
      });
    },
    profiles() {
      const urls = {};

      if (this.contact && Array.isArray(this.contact.profiles) && this.contact.profiles.length) {
        const { profiles } = this.contact;

        const { clean: facebookURL } = profiles.find(p => p && p.clean && p.domain === 'facebook.com') || {};
        urls.facebook = facebookURL;

        const { clean: twitterURL } = profiles.find(p => p && p.clean && p.domain === 'twitter.com') || {};
        urls.twitter = twitterURL;

        const { clean: linkedInURL } = profiles.find(p => p && p.clean && p.domain === 'linkedin.com') || {};
        urls.linkedin = linkedInURL;
      }

      return Object.keys(urls).length ? urls : null;
    },
  },
  methods: {
    formatDate,
    // remove() {
    //   const r = confirm('Are you sure you want to remove them from your contacts list? This will remove them completely from the system, unless they are connected to someone else in the company.');
    //   if (r) {
    //     // mark contact to be removed.
    //   }
    // },
    show() {
      this.visible = true;
    },
  },
};
</script>

<style lang="scss">
@import './../scss/variables';
.contact-profile-modal {
  .modal-body {
    padding-top: 2rem;

    .footer-buttons {
      margin-left: 2em;
      margin-right: 2em;
      // padding-bottom: 4rem;
    }
    .trash {
      padding-top: 2em;
      text-align: left;
      font-size: $small-font-size;
      .svg-inline--fa {
        margin-right: 0.3em;
      }
    }

  }

  .history {
    .history-title {
      margin-bottom: 0.5em;
      display: block;
    }

    > .col {
      padding: 0.5em;
      margin-top: 2rem;
      border: 1px;
      border-style: solid;
      border-left-style: none;
      border-right-style: none;
      border-color: #dadada;
    }

    .history-block {
      margin-bottom: 1em;
      font-size:  $small-font-size;
    }
  }

  .contact-picture {
    position: relative;
    margin: 0 auto;
    display: block;
  }

  .location {
    font-size: $small-font-size;
    margin: 0 auto;
    padding: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/modals/contact-profile.vue